<template>
    <div>
	
        <Modal v-model="show" 
            :width="1300"
			draggable
			:footer-hide="true"
            title="定金单明细">
			<div style="max-height:600px;overflow-y:auto;overflow-x:hidden;">		
		
			<Loading :isLoading="spinShow" />
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
				<div class="global-tool-bar">
				    <div class="left-bar">
				    </div>
				    <div class="right-bar" style="margin-bottom:20px;">
						 <Button v-if="showTotalBtn" type="success" style="background-color: #d40909;border-color:#d40909;"
						     @click="payTotalMoney()">支付总额</Button>
						<Button v-if="hideTotalBtn" type="success" disabled style="background-color: #e0e0ea;border-color:#e0e0ea;margin-left: 10px;">支付总额</Button>
				        <Button v-if="showDepositBtn&&isShowDeposit" type="success"  style="background-color: #389301;border-color:#389301;margin-left: 10px;"
				            @click="payDepositMoney()">支付定金</Button>
						<Button v-if="hideDepositBtn" type="success" disabled style="background-color: #e0e0ea;border-color:#e0e0ea;margin-left: 10px;">支付定金</Button>
						<!-- <Button v-if="showRemainingBtn" type="success" style="background-color: #fe8401;border-color:#fe8401;margin-left: 10px;"
							@click="payRemainingMoney()">支付余额</Button> -->
						<!-- <Button v-if="hideRemainingBtn" type="success" disabled style="background-color: #e0e0ea;border-color:#e0e0ea;margin-left: 10px;">支付余额</Button> -->
				    </div>
				</div>
				<div class="contract-btn-wrapper">
					<Button 
						type="primary"
						shape="circle"
						icon="ios-document-outline"
						@click="showContract"
						:loading="contractLoading"
						class="contract-btn"
					>
						查看种苗定购协议
					</Button>
				</div>
                <Row :gutter="24" v-for="(depositBillMainVO, index) in depositBillMainVOList" :key="index" style="border:1px solid #dddddd;margin-top:16px;background-color:#F7F7F7;padding:10px;border-radius: 3px;margin-left:0px;margin-right:0px;">
                    <Col span="24">
						<Form label-position="top"
							class="form-input-no-outline">
							<Row :gutter="24">
								<Col span="4">
								<FormItem label="定金单编号">
									<Input :value="depositBillMainVO.billCode" disabled></Input>
								</FormItem>
								</Col>
								<Col span="4">
								<FormItem label="苗场">
									<Input :value="depositBillMainVO.seedFarmName" disabled></Input>
								</FormItem>
								</Col>
								<Col span="4">
								<FormItem label="周次">
									<Input :value="depositBillMainVO.weekSeq" disabled></Input>
								</FormItem>
								</Col>
								<Col span="4">
								<FormItem label="发货时间">
									<Input :value="depositBillMainVO.sendProductDate" disabled></Input>
								</FormItem>
								</Col>
								<Col span="4">
								<FormItem label="客户名称">
									<Input :value="depositBillMainVO.userName" disabled></Input>
								</FormItem>
								</Col>
								<Col span="4">
								<FormItem label="联系方式">
									<Input :value="depositBillMainVO.contactNumber" disabled></Input>
								</FormItem>
								</Col>
							</Row>
							<!-- 新增客户地址和苗场备注 -->
							<Row :gutter="24">
								<Col span="12">
								<FormItem label="收货地址">
									<Input :value="depositBillMainVO.receiptFullAddress" disabled></Input>
								</FormItem>
								</Col>
								
								<Col span="12">
								<FormItem label="苗场备注">
									<Input :value="depositBillMainVO.remark" disabled type="textarea"></Input>
								</FormItem>
								</Col>
							</Row>
							<Row :gutter="24">
								<Col span="24">
									<div style="width: 100%;text-align: right;" v-if="$checkAccessArray(['B','C','G'])">
										<Poptip v-show="saveBtnFlag" 
										   confirm
										   placement="left"
										   title="请确认定金金额是否无误？"
										   @on-ok="saveDetailInfo(depositBillMainVO)"
										   @on-cancel="cancel" style="text-align: left;">
										   <Button type="primary">保存修改</Button>
										</Poptip>
									</div>
									<FormItem>
										<div slot="label"><b>定金单明细</b>
										</div>
										<Table ref="mainTable"
											size="small"
											:columns="orderDetail.columns"
											:data="depositBillMainVO.orderItmeList"
											stripe
											border />
									</FormItem>
								</Col>
							</Row>
						</Form>
                    </Col>
                </Row>
            </Card>
			</div>
			<payModalDetail ref="PayModal" />
        </Modal>
		
    </div>
</template>

<script>
import { formatDateTimeString } from '@/libs/logic';
import CurrencyInput from '@/components/number-input/currency-input';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import {
    dateRender,
    dateTimeRender
} from '@/libs/tableRowTimeRender';

import {
    getUserDepositBillInfoListBySendProDate,
    webPreSaleDepositPayWithFund,
    updateDepositBillRecordForDepositMoney,
    getDepositBillInfoByRecordUuid
} from '@/api/modules/sale-management/sale-approve';
import {
    ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID
} from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import payModalDetail from './pay';
import Loading from '@/components/loading/Loading.vue';
import { DOWNLOAD_SERVER, FILE_SERVER } from '@/api/modules/files';
import { webGetContract } from '@/api/modules/sale-management/sale-approve';
export default {
    name: 'DepositOrderDetailB',
    components: {
        CurrencyInput,
        DecimalInput,
        IntegerInput,
        payModalDetail,
        Loading
    },
    data() {
        return {
            saveBtnFlag:true,
            clickRepeat:false,
            showTotalBtn:true,
            hideTotalBtn:false,
            showDepositBtn:true,
            hideDepositBtn:false,
            showRemainingBtn:false,
            hideRemainingBtn:true,
            show:false,
            spinShow:false,
            contractLoading: false,
            userUuid:'',
            depositBillRecordUuid:'',
            depositBillRecordUuidArray: [],
            depositBillMainVOList: [],
            sendProductDateArray: [],
            orderRecord: {},
            pageLoading: false,
            orderDetail: {
                columns: [
                    {
						    title: '序号',
                        align: 'center',
                        width:'50',
						    render:(h, params) =>{
                            if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
									 h('span', '');
                            }
                            else{
                                return h('span', params.index+1);
                            }
						    }
                    },
                    {
                        title: "产品编号",
                        key: "productCode"
                    },
                    {
						    title: '产品名称',
                        align: 'center',
                        width:160,
						    key: 'productName',
						       render: (h, params) => {
							   if(params.row.preSalePlanPrice=='定金'){
								   const minValue = this.$checkAccessArray(['B', 'C']) ? 0 : 20;
								   return h('InputNumber', {
									   props:{
										   min: minValue,
										   max: 100,
										   value: parseFloat(params.row.productName)
									   },
									   style:{
										   height: "30px !important",
										   width: "95%"
									   },
									   on:{
										   'on-change':(event)=>{
											   // console.log("InputNumber:",event);
											   params.row.productName = event;
											   this.updateRow(params.row, params.index);
										   }
									   }
                                });
							   }
							  else{
								  return h('span', params.row.productName);
							  }
						    }
                    },
                    {
                        title: "单位",
                        key: "unitName"
                    },
                    {
                        title: "数量",
                        key: "orderQuantity",
                        render: (h, params) => {
                            if (params.row.productCode &&params.row.productCode!='定金收取(%)') {
                                return h('span', parseFloat(params.row.orderQuantity));
                            }
                            else {
                                return h('span', params.row.orderQuantity);
                            }
                        }
                    },
                    {
                        title: "单价",
                        key: "preSalePlanPrice"
                    },
                    {
						    title: '金额',
                        align: 'center',
                        width:160,
						    key: 'totalMoney',
						       render: (h, params) => {
							   if(params.row.preSalePlanPrice=='定金'){
								   return h('InputNumber', {
									   props:{
										   min: 0,
										   max: 10000000,
										   value: parseFloat(params.row.totalMoney)
									   },
									   style:{
										   height: "30px !important",
										   width: "95%"
									   },
									   on:{
										   'on-change':(event)=>{
											   // console.log("InputNumber:",event);
											   params.row.totalMoney = event;
											   this.updateRowTotalMoney(params.row);
										   }
									   }
                                });
							   }
							  else if(params.row.productName=='折扣'||params.row.preSalePlanPrice=='总额'){
                                return h('span', params.row.totalMoney.toFixed(2));
							   }
							  else{
								  return h('span', params.row.totalMoney);
							  }
						    }
                    }
                ],
                rows: []
            }
        };
    },
    computed: {
        isShowDeposit(){
            let result=this.depositBillMainVOList.some(x=>x.productDepositValue==x.totalFee);
            return !result;
        }
    },
    mounted() {

    },
    methods: {
        updateRow(row, index){
            let totalMoney=0;
            let depositMoney=0;
            this.depositBillMainVOList.forEach(obj =>{
                obj.orderItmeList.forEach(item =>{
                    if(item.preSalePlanPrice=='金额合计'&&item.depositBillRecordUuid==row.depositBillRecordUuid){
                        totalMoney=item.totalMoney;
                    }
                });
            });
				
            this.depositBillMainVOList.forEach(obj =>{
                obj.orderItmeList.forEach(item =>{
                    if(item.preSalePlanPrice=='定金'&&item.depositBillRecordUuid==row.depositBillRecordUuid){
                        item.productName=row.productName;
                        depositMoney=(totalMoney*row.productName/100).toFixed(2);
                    }
                });
            });
				
            this.depositBillMainVOList.forEach(obj =>{
                obj.orderItmeList.forEach(item =>{
                    if(item.preSalePlanPrice=='定金'&&item.depositBillRecordUuid==row.depositBillRecordUuid){
                        item.totalMoney=depositMoney;
                    }
                });
            });
            row.totalMoney=depositMoney;
        },
        updateRowTotalMoney(row){
            let totalMoney=0;
            let depositValue=0;
            this.depositBillMainVOList.forEach(obj =>{
                obj.orderItmeList.forEach(item =>{
                    if(item.preSalePlanPrice=='金额合计'&&item.depositBillRecordUuid==row.depositBillRecordUuid){
                        totalMoney=item.totalMoney;
                    }
                });
            });
				
            this.depositBillMainVOList.forEach(obj =>{
                obj.orderItmeList.forEach(item =>{
                    if(item.preSalePlanPrice=='定金'&&item.depositBillRecordUuid==row.depositBillRecordUuid){
                        item.totalMoney=row.totalMoney;
                        depositValue=((row.totalMoney/totalMoney)*100).toFixed(0);
                    }
                });
            });
				
            this.depositBillMainVOList.forEach(obj =>{
                obj.orderItmeList.forEach(item =>{
                    if(item.preSalePlanPrice=='定金'&&item.depositBillRecordUuid==row.depositBillRecordUuid){
                        item.productName=depositValue;
                    }
                });
            });
            row.productName=depositValue;
        },
        saveDetailInfo(depositBillMainVO){
            let depositRatio=0;
            let depositValue=0;
            this.spinShow=true;
            depositBillMainVO.orderItmeList.forEach(item =>{
                if(item.preSalePlanPrice=='定金'){
                    depositRatio=item.productName;
                    depositValue=item.totalMoney;
                }
            });
            let data = {
				    depositBillRecordUuid:depositBillMainVO.depositBillRecordUuid,
				    depositRatio:depositRatio,
                depositValue:depositValue
            };
            let isSign = this.$checkAccessArray(['B', 'C']) ? true : false;
            if(isSign){
                data = {
					    depositBillRecordUuid:depositBillMainVO.depositBillRecordUuid,
					    depositRatio:depositRatio,
                    depositValue:depositValue,
                    isDepositDueRate: 'YES'
                };
            }
				
            updateDepositBillRecordForDepositMoney(data).then(res => {
				    if (res.code === 0) {
                    if(this.sendProductDateArray){
                        this.$parent.getUserOrderInfo();
                    }
                    this.spinShow=false;
                    this.init();
                    this.$Message.success('修改定金金额成功！');
				    }
                else{
                    this.spinShow=false;
                    this.$Message.error(res.message);
                }
            }).catch(err=>{
                this.spinShow=false;
                this.$Message.error(err);
            });
        },
        cancel() {
			    this.$Message.info('请再次确认信息');
        },
        payTotalMoney(){
            if(this.clickRepeat){
                return;
            }
            let data = {
				    depositBillRecordUuidArray: this.depositBillRecordUuidArray,
				    orderType: 'TOTALMONEY'
            };
            this.clickRepeat=true;
            this.spinShow=true;
            webPreSaleDepositPayWithFund(data).then(res => {
                this.clickRepeat=false;
                this.spinShow=false;
				    if (res.code === 0) {
                    this.$parent.getUserOrderInfo();
                    this.showTotalBtn=false;
                    this.hideTotalBtn=true;
                    this.showDepositBtn=false;
                    this.hideDepositBtn=true;
                    this.showRemainingBtn=false;
                    this.hideRemainingBtn=true;
                    this.$Message.success('支付总额成功！');
				    }
                else if(res.code === 4){
                    this.$refs.PayModal.showModal(this.userUuid);
                }
            });
        },
        payDepositMoney(){
            if(this.clickRepeat){
                return;
            }
            this.spinShow=true;
            let data = {
				    depositBillRecordUuidArray: this.depositBillRecordUuidArray,
				    orderType: 'DEPOSIT'
            };
            let isSign = this.$checkAccessArray(['B', 'C']) ? true : false;
            if(isSign){
                data = {
					    depositBillRecordUuidArray: this.depositBillRecordUuidArray,
					    orderType: 'DEPOSIT',
                    isDepositDueRate: 'YES'
                };
            }
            this.clickRepeat=true;
            webPreSaleDepositPayWithFund(data).then(res => {
                this.clickRepeat=false;
                this.spinShow=false;
				    if (res.code === 0) {
                    this.$parent.getUserOrderInfo();
                    this.showTotalBtn=false;
                    this.hideTotalBtn=true;
                    this.showDepositBtn=false;
                    this.hideDepositBtn=true;
                    this.showRemainingBtn=true;
                    this.hideRemainingBtn=false;
                    this.$Message.success('支付定金成功！');
				    }
                else if(res.code === 4){
                    this.$refs.PayModal.showModal(this.userUuid);
                }
            });
        },
        payRemainingMoney(){
            if(this.clickRepeat){
                return;
            }
            this.spinShow=true;
            let data = {
				    depositBillRecordUuidArray: this.depositBillRecordUuidArray,
				    orderType: 'REMAININGMONEY'
            };
            this.clickRepeat=true;
            webPreSaleDepositPayWithFund(data).then(res => {
                this.clickRepeat=false;
                this.spinShow=false;
				    if (res.code === 0) {
                    if(this.depositBillRecordUuid){
                        this.$parent.getDepositPaidOrderList();
                    }
                    else{
                        this.$parent.getUserOrderInfo();
                    }
						
                    this.showTotalBtn=false;
                    this.hideTotalBtn=true;
                    this.showDepositBtn=false;
                    this.hideDepositBtn=true;
                    this.showRemainingBtn=false;
                    this.hideRemainingBtn=true;
                    this.$Message.success('恭喜你！支付余额成功,请前往发货单列表查看！');
                    this.show = false;
				    }
                else if(res.code === 4){
                    this.$refs.PayModal.showModal(this.userUuid);
                }
            });
        },
        formatDateTimeString,
        showModal(sendProductDateArray, userUuid, depositBillRecordUuid) {
            this.depositBillRecordUuid='';
            this.sendProductDateArray ='';
            this.depositBillRecordUuidArray=[];
            this.depositBillMainVOList=[];
            if(depositBillRecordUuid!=''){
                this.saveBtnFlag=false;
                this.showTotalBtn=false;
                this.hideTotalBtn=false;
                this.showDepositBtn=false;;
                this.hideDepositBtn=false;
                this.showRemainingBtn=true;
                this.hideRemainingBtn=false;
                this.depositBillRecordUuid = depositBillRecordUuid;
                this.userUuid=userUuid;
                this.init();
                this.show = true;
            }
            else{
                this.saveBtnFlag=true;
                this.showTotalBtn=true;
                this.hideTotalBtn=false;
                this.showDepositBtn=true;;
                this.hideDepositBtn=false;
                this.showRemainingBtn=false;
                this.hideRemainingBtn=true;
                this.sendProductDateArray = sendProductDateArray;
                this.userUuid=userUuid;
                this.init();
                this.show = true;
            }
				
        },
        init() {
            if(this.depositBillRecordUuid){
                getDepositBillInfoByRecordUuid({ depositBillRecordUuid:this.depositBillRecordUuid }).then(res => {
					    if (res.code === 0) {
					        if(res.data.depositBillMainVOList!=null){
					            this.depositBillMainVOList=res.data.depositBillMainVOList;
                            this.depositBillMainVOList.forEach((item) => {
                                this.depositBillRecordUuidArray.push(item.depositBillRecordUuid);
                            });
					        }
					    }
                }).catch(() => {
                });
            }
            else{
                if (this.sendProductDateArray) {
                    this.depositBillRecordUuidArray=[];
                    let sendProductDate=JSON.parse(decodeURIComponent(this.sendProductDateArray));
					    getUserDepositBillInfoListBySendProDate({ sendProductDateArray:sendProductDate, paidStatus:'未支付', isSign:1, userUuid:this.userUuid }).then(res => {
					        if (res.code === 0) {
					            if(res.data.depositBillMainVOList!=null){
					                this.depositBillMainVOList=res.data.depositBillMainVOList;
					                this.depositBillMainVOList.forEach((item) => {
					                	this.depositBillRecordUuidArray.push(item.depositBillRecordUuid);
					                });
					            }
					        }
					    }).catch(() => {
					    });
                }
            }
        },
			
        showContract() {
            this.contractLoading = true;

            const {
                orderItmeList,
                depositBillRecordUuid,
                depositBillRecordDeliveryAddressUuid
            } = this.depositBillMainVOList[0];

            // 日期格式化函数
            const formatDate = (dateString) => {
                if (!dateString) return '';
                const date = new Date(dateString);
                return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
            };

            // 使用map和filter简化数组处理
            const cartItems = orderItmeList
                .filter(item => item.productCode)
                .map(({
                    productName,
                    unitName,
                    productCode,
                    preSalePlanPrice: displayPrice,
                    orderQuantity,
                    sendProductDate
                }) => ({
                    productUuid: '',
                    brandName: '',
                    productName,
                    unitName,
                    productCode,
                    displayPrice,
                    orderQuantity,
                    sendDate: formatDate(sendProductDate) // 使用格式化后的日期
                }));

            // 提取请求参数
            const params = {
                items: cartItems,
                depositBillRecordUuid,
                memberDeliveryAddressUuid: depositBillRecordDeliveryAddressUuid
            };

            // 处理响应和错误的通用函数
            const handleError = (message) => {
                this.contractLoading = false;
                this.$Message.error(message);
            };

            webGetContract(params)
                .then(res => {
                    this.contractLoading = false;
                    if (res.code === 0) {
                        this.contractPath = res.data.url;
                        const url = DOWNLOAD_SERVER + res.data.url.replace(/\\/g, '/');
                        window.open(url, '_blank');
                    }
                    else {
                        handleError("生成合同失败，请联系客户经理！");
                    }
                })
                .catch(error => {
                    console.error('Contract generation failed:', error);
                    this.contractLoading = false;
                    handleError("生成合同时发生错误，请联系客户经理！");
                });
        }
    }
};
</script>

<style>
.ivu-table-cell{
	text-align: center;
}
.ivu-table-small th{
	text-align: center;
	}
.ivu-table th, .ivu-table td{text-align: center !important;}
th.ivu-table-column-left, td.ivu-table-column-left{text-align: center !important;}
th.ivu-table-column-right, td.ivu-table-column-right{text-align: center !important;}
.ivu-input-number-input{text-align: center;}
.contract-btn-wrapper {
	margin: 16px 0;
	.contract-btn {
		padding: 0 20px;
		height: 36px;
		font-size: 14px;
		transition: all 0.3s ease;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 4px 12px fade(@primary-color, 30%);
		}

		&:active {
			transform: translateY(0);
		}
	}
}
</style>
